import PicklistMetadata from "../PicklistMetadata";

// Positions the current user is a member of (display = Name, value = USID). Sourced client-side from
// SessionContext.getAccount().Positions (the login-payload list, filtered server-side to the user's
// own memberships). Used for PRIMARY Position (stewardship owner) pickers — a steward can only assign
// a term's primary to a position they belong to. The realm-wide "all positions" list used by the
// Add-Shared-Position picker is a separate picklist ("PositionShared", EC-backed).
class PositionPicklistMetadata extends PicklistMetadata {
    constructor() {
        super();

        this.name = "Position";
        this.static = true;
        this.companySource = "Positions";
        this.useRealm = false;
        this.typeField = "Name";
        this.typeValue = "USID";
        this.allowNoSelection = false;
    }
}

export default PositionPicklistMetadata;
